module.exports = __webpack_public_path__ + "401ae04a728e8924033a0f43d9d37148.svg";